<template>
  <div>
    <FloatingMenu />
    <MenuBar />

    <div class="mobileOnly">
      <div id="aboutUsPage" v-if="this.langChosen === 'gr'">
        <transition enter-active-class="animated fadeIn" appear>
          <div class="aboutUsPageTitle">เกี่ยวกับเรา</div>
        </transition>

        <div class="heroImage" />

        <div class="contactContainer">
          <p>
            กรุงเทพลอตเตอรี่มุ่งมั่นที่จะเป็น บริษัท เกมระดับโลกที่มีความรับผิดชอบ ความประพฤติอย่างมืออาชีพของเราและ
            พฤติกรรมทางธุรกิจต้องได้รับการปฏิบัติตามมาตรฐานสูงสุดเพื่อให้แน่ใจว่ามีการพนันที่ยุติธรรมและปลอดภัย
            ประสบการณ์ในการปกป้องลูกค้าของเรา
          </p>

          <p>
            หลายคนที่ชอบเกมของเราเล่นเพื่อความกระพือปีกหรือพักผ่อนหย่อนใจทางสังคม
            อย่างไรก็ตามเราตระหนักดีว่าอาจมีคนส่วนน้อยที่อาจเล่นเกินกำลัง
            ด้วยเหตุนี้เราจึงมีมาตรการป้องกันเพื่อช่วยสร้างสภาพแวดล้อมการเล่นเกมที่มีความรับผิดชอบสำหรับทุกคน
          </p>

          <p>
            เราออกแบบและสื่อสารผลิตภัณฑ์ของเราในลักษณะที่จะไม่ส่งเสริมการเล่นที่มากเกินไปและขาดความรับผิดชอบ
            เรามีจำนวนเงินเดิมพันขั้นต่ำที่ต่ำและเสนอการเดิมพันกีฬาที่หลากหลาย
          </p>

          <p>
            เราเชื่อมั่นในการให้บริการลูกค้าที่มีความรับผิดชอบและดี
            เราแจ้งและให้ความรู้กับลูกค้าในเชิงรุกในการเดิมพันอย่างมีความรับผิดชอบและวิธีการขอความช่วยเหลือหากพวกเขาต้องการ
          </p>
        </div>
      </div>

      <div id="aboutUsPage" v-else>
        <transition enter-active-class="animated fadeIn" appear>
          <div class="aboutUsPageTitle">About Us</div>
        </transition>

        <div class="heroImage" />

        <div class="contactContainer">
          <p>
            Bangkok Lotteries is committed to be a world-class responsible gaming company. Our professional conduct and
            business behaviours must be upheld to the very highest standards, ensuring a fair and safe gambling
            experience to protect our customers.
          </p>

          <p>
            Many who like our games play for just a little flutter or social recreation. However, we recognize there may
            be a minority who may play beyond their means. As such, we have safeguards in place to help create a
            responsible gaming environment for all.
          </p>

          <p>
            We design and communicate our products in a manner that will not promote excessive and irresponsible play.
            We have low minimum bet amounts and offer a conservative range of sports bets.
          </p>

          <p>
            We believe in delivering responsible and good customer service. We proactively inform and educate our
            customers to bet responsibly, and how to get help should they need it.
          </p>
        </div>
      </div>
    </div>

    <div id="aboutDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">เกี่ยวกับเรา</div>
          <div v-else>About Us</div>
        </transition>
      </div>

      <div class="flex">
        <div class="adsSpace1 desktopOnly">
          <a href="https://www.discoverthailandco.com" target="_blank">Bangkok. Enjoy your moment.</a>
        </div>

        <div class="aboutDesktopField">
          <div v-if="this.langChosen === 'gr'">
            <p>
              กรุงเทพลอตเตอรี่มุ่งมั่นที่จะเป็น บริษัท เกมระดับโลกที่มีความรับผิดชอบ
              การปฏิบัติอย่างมืออาชีพและพฤติกรรมทางธุรกิจของเราต้องได้รับการปฏิบัติตามมาตรฐานสูงสุดเพื่อให้แน่ใจว่าประสบการณ์การพนันที่ยุติธรรมและปลอดภัยเพื่อปกป้องลูกค้าของเรา
            </p>

            <p>
              หลายคนที่ชอบเกมของเราเล่นเพื่อความกระพือปีกหรือพักผ่อนหย่อนใจทางสังคม
              อย่างไรก็ตามเราตระหนักดีว่าอาจมีคนส่วนน้อยที่อาจเล่นเกินกำลัง
              ด้วยเหตุนี้เราจึงมีมาตรการป้องกันเพื่อช่วยสร้างสภาพแวดล้อมการเล่นเกมที่มีความรับผิดชอบสำหรับทุกคน
            </p>

            <p>
              เราออกแบบและสื่อสารผลิตภัณฑ์ของเราในลักษณะที่จะไม่ส่งเสริมการเล่นที่มากเกินไปและขาดความรับผิดชอบ
              เรามีจำนวนเงินเดิมพันขั้นต่ำที่ต่ำและเสนอการเดิมพันกีฬาที่หลากหลาย
            </p>

            <p>
              เราเชื่อมั่นในการให้บริการลูกค้าที่มีความรับผิดชอบและดี
              เราแจ้งและให้ความรู้กับลูกค้าในเชิงรุกในการเดิมพันอย่างมีความรับผิดชอบและวิธีการขอความช่วยเหลือหากพวกเขาต้องการ
            </p>
          </div>

          <div v-else>
            <p>
              Bangkok Lotteries is committed to being a world-class responsible gaming company. Our professional conduct
              and business behaviours must be upheld to the very highest standards, ensuring a fair and safe gambling
              experience to protect our customers.
            </p>

            <p>
              Many who like our games play for just a little flutter or social recreation. However, we recognize there
              may be a minority who may play beyond their means. As such, we have safeguards in place to help create a
              responsible gaming environment for all.
            </p>

            <p>
              We design and communicate our products in a manner that will not promote excessive and irresponsible play.
              We have low minimum bet amounts and offer a conservative range of sports bets.
            </p>

            <p>
              We believe in delivering responsible and good customer service. We proactively inform and educate our
              customers to bet responsibly, and how to get help should they need it.
            </p>
          </div>
        </div>

        <div class="adsSpace2 desktopOnly">
          <a href="https://www.tourismthailand.org" target="_blank">Visit Thailand!</a>
        </div>
      </div>
    </div>

    <FifthSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FifthSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';

export default {
  components: {
    FloatingMenu,
    FifthSection,
    MenuBar,
  },

  mounted() {
    this.setDocTitle();
  },

  methods: {
    setDocTitle() {
      const langChosen = localStorage.getItem('langChosen');
      if (langChosen == 'gr') return (document.title = 'เกี่ยวกับเรา - Bangkok Lottery');
      document.title = 'About Us - Bangkok Lotteries';
    },
  },
};
</script>

<style>
#aboutUsPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  padding: 5vw;
  padding-top: 3.75vh;
  box-sizing: border-box;
}

.aboutUsPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
  margin-bottom: 5.5vw;
}

#aboutUsPage .heroImage {
  height: 35vh;
  background: url('../assets/office-team.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2vw 2vw 0 0;
  overflow: hidden;
}

.contactContainer {
  background-color: white;
  padding: 4vw;
  border-radius: 0 0 2vw 2vw;
  font-size: 0.98em;
}

.contactContainer p {
  margin: 0;
  margin-bottom: 3vw;
}

.contactContainer p:last-child {
  margin-bottom: 1vw;
}

#aboutDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  .mobileOnly {
    display: none;
  }

  #aboutDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #aboutDesktop .heroHeader {
    background-image: url('../assets/office-team.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: center;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #aboutDesktop .adsSpace1,
  #aboutDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
}
</style>
